import React, { useRef } from 'react';
import { m, useInView } from 'framer-motion';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useColorScheme } from '@mui/material';

import { CONFIG } from 'src/global-config';
import { Image } from 'src/components/image';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

export function VisionAndMission({ sx, ...other }) {
  const { t } = useLocale();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <Box
      ref={ref}
      component="section"
      sx={[
        {
          overflow: 'hidden',
          py: { xs: 5, md: 4 },
          textAlign: { xs: 'center', md: 'unset' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Grid
          container
          spacing={{ xs: 5, md: 3 }}
          sx={{ justifyContent: 'center', gap: { xs: 5, md: 10 } }}
          alignItems={'center'}
        >
          {/* <Grid size={{ xs: 12, md: 3 }}>
            <m.div
              initial={{ opacity: 0, y: -80 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{ mt: { md: 5 } }}>
                {t('Our_Vision')}
              </Typography>

              <Typography sx={{ color: 'text.secondary', mt: 3 }}>
                {t('Our_Vision_Desc')}
              </Typography>
            </m.div>
          </Grid> */}

          <Grid sx={{ display: { xs: 'none', md: 'block' } }} size={{ xs: 12, md: 4.5 }}>
            <m.div
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, ease: 'easeOut' }}
            >
              <Image
                alt={t('Heavy_haulage_and_freight_transport_specialists_in_Saudi_Arabia')}
                src={`${CONFIG.assetsDir}/assets/images/home/about/heavy-haulage-transport-company-ksa.webp`}
                ratio="3/4"
                sx={{ borderRadius: 2, width: '100%' }}
                priority
              />
            </m.div>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <m.div
              initial={{ opacity: 0, y: -80 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{}}>
                {t('Our_Mission')}
              </Typography>

              <Typography sx={{ color: 'text.secondary', mt: 3 }}>
                {t('Our_Mission_Desc')}
              </Typography>
            </m.div>
            <m.div
              initial={{ opacity: 0, y: -80 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, ease: 'easeOut' }}
            >
              <Typography variant="h3" sx={{ mt: 3 }}>
                {t('Our_Vision')}
              </Typography>

              <Typography sx={{ color: 'text.secondary', mt: 3 }}>
                {t('Our_Vision_Desc')}
              </Typography>
            </m.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
